export function useIsWideEmbed(): boolean {
    return window.innerWidth >= 800 ? true : false;
}
